"use strict";

exports.__esModule = true;
exports.VAT_COUNTRIES_MAP = exports.VAT_COUNTRIES = exports.VALID_NUMBER_WITH_ZERO_IN_BEGINNING = exports.VALID_NUMBER_WITHOUT_ZERO_IN_BEGINNING = exports.STORAGE_KEYS = exports.SPECIAL_FORMAT_DIAL_CODES = exports.SENTRY = exports.POSConfig = exports.POLLING_STATE = exports.OPEN_GRAPH_IMAGE = exports.LOWEST_VALID_PHONE_NUMBER = exports.LOCALES = exports.LANGUAGE = exports.HOUR_MINUTES = exports.GOOGLE_MAPS_KEY = exports.EVENTS = exports.ERRORS = exports.ENV = exports.ENDPOINTS = exports.EMAIL_REGEX = exports.EMAILS = exports.DOMAINS = exports.DATA_SOURCES = exports.CURRENCY = exports.CREDIT_CARDS = exports.COUNTRY_CURRENCY_MAP = exports.COUNTRY_CODE_MAP = exports.COUNTRY_CODE = exports.CONNECTION_STATUS = exports.BRANDS_PREFIX = exports.BRANDS = exports.APP_ROUTES = exports.APP_PAGES = exports.API_STATE = exports.ALLOWED_CURRENCIES = void 0;
const ERRORS = {
  ERROR_CODES: "errorCodes",
  DEFAULT_ERROR_CODE: "Something went wrong please try again",
  ON_LOAD_ERROR: "errors_onload",
  RESPONSE_STATUS_TYPE_REF: "https://www.w3.org/Protocols/rfc2616/rfc2616-sec10.html"
};
exports.ERRORS = ERRORS;
const API_STATE = {
  INITIAL: "INITIAL",
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
}; // production

exports.API_STATE = API_STATE;
const GOOGLE_MAPS_KEY = "AIzaSyCwZP4dtT6dxOEzD8nI3jEDFs1ZtXC3BMA"; // development
// export const GOOGLE_MAPS_KEY = `AIzaSyDck5G1hxI3qunAyPA0U_OxEJNPhyFiZzE`;

exports.GOOGLE_MAPS_KEY = GOOGLE_MAPS_KEY;
const POLLING_STATE = {
  POLLING_START: "POLLING_START",
  POLLING_RETRY: "POLLING_RETRY",
  POLLING_IN_PROGRESS: "POLLING_IN_PROGRESS",
  POLLING_FAILED: "POLLING_FAILED",
  POLLING_END: "POLLING_END"
};
exports.POLLING_STATE = POLLING_STATE;
const SENTRY = {
  DSN: {
    DESKTOP: "https://ccfd7a6eb88745c098eb8997b8847e8c@sentry.io/1407024",
    MWEB: "https://507b0e54bef44ae3810a13231a359810@sentry.io/1445426",
    HOME: "https://2ff2de4309df431d826f92213fd06fc0@sentry.io/1446253",
    FLIGHTS: "https://3ebc3a8be84e49489a46e0a0faf2004c@sentry.io/1446263",
    HOTELS: "https://e90c6d297f7c40fab647ca28dd6a5fb4@sentry.io/1515842",
    PAYMENT: "https://3b6ef80134df4e38882690e39509f45f@sentry.io/1446265"
  },
  VERTICAL: {
    HOME: "HOME",
    FLIGHTS: "FLIGHTS",
    HOTELS: "HOTELS",
    PAYMENT: "PAYMENT",
    MWEB: "MWEB"
  },
  TAGS: {
    API_ERROR: "API_ERROR",
    REACTION: "REACTION",
    UI_ERROR: "UI_ERROR"
  }
};
exports.SENTRY = SENTRY;
const ENDPOINTS = {
  CURRENCY_LIST: "/api/system/currency/list",
  COUNTRY_LIST: "/api/system/country/list",
  INSURANCE_PLANS: "/api/insurance/plan",
  APPLY_INSURANCE: "/api/insurance/cart",
  REMOVE_INSURANCE_PLAN: "/api/insurance/cart/{cartId}/product/{productId}",
  TOKEN_VISA_URL: "/api/payment-api/card/visa-checkout",
  CHECK_PAYMENT_3D_SECURE: "/api/check-payment-3ds?_c={pollingCount}&_t={pollingStartTime}",
  CMS_PAGE: "/api/cms/page",
  CMS_PAGE_NO_CACHE: "/api/cms/page?no-cache=true",
  SUB_NEWSLETTER: "/api/account/newsletter/subscribe",
  GOOGLE_TRANSLATION: "/api/hotel/ahs/cancellation-policy/translateRemarks"
};
exports.ENDPOINTS = ENDPOINTS;
const EVENTS = {
  APP_ERROR: "app-error",
  FLIGHT: "event.flight",
  FLIGHT_NON_INTERACTIVE: "event.noninteractive.flight",
  CONTENT_VIEW: "content-view",
  HEADER: "Header",
  FLIGHT_SEARCH: "flight.search",
  FLIGHT_MODIFY_SEARCH: "flight.modify-search",
  FLIGHT_SEARCH_DETAIL: "flight.search-details",
  FLIGHT_RESULTS: "flight.results",
  FLIGHT_SELECT: "flight.select",
  FLIGHT_DETAILS: "flight.details",
  FLIGHT_BOOKING: "flight.booking",
  FLIGHT_SEARCH_TEALIUM: "flight_search",
  FLIGHT_DETAILS_TEALIUM: "flight_details",
  FLIGHT_PAX_TEALIUM: "flight_travelers",
  FLIGHT_PAYMENT_METHOD_TEALIUM: "flight_payment_method",
  FLIGHT_PAYMENT_TEALIUM: "flight_payment",
  FLIGHT_CONFIRMATION_TEALIUM: "flight_confirmation"
};
exports.EVENTS = EVENTS;
const CURRENCY = {
  BASE_NAME: "Saudi Riyal",
  BASE_PLURAL: "Saudi Riyal",
  BASE_SYMBOL: "SAR",
  DEFAULT_ROUNDING: 0,
  DEFAULT_DECIMAL_DIGITS: 2
};
exports.CURRENCY = CURRENCY;
const STORAGE_KEYS = {
  AUTH_TOKEN: "token",
  CURRENCY_LIST: "CURRENCY_LIST",
  CURRENCY: "currency",
  LANGUAGE: "language",
  COUNTRY_LIST: "COUNTRY_LIST",
  CACHED_TRAVELLERS: "CACHED_TRAVELLERS"
};
exports.STORAGE_KEYS = STORAGE_KEYS;
const CONNECTION_STATUS = {
  ONLINE: "online",
  OFFLINE: "offline"
};
exports.CONNECTION_STATUS = CONNECTION_STATUS;
const BRANDS = {
  TAJAWAL: "tajawal",
  ALMOSAFER: "almosafer"
};
exports.BRANDS = BRANDS;
const OPEN_GRAPH_IMAGE = {
  [BRANDS.TAJAWAL]: "http://cms-seo-prod.s3.eu-west-1.amazonaws.com/tjwl/files/2019-04/hero_0.jpg",
  [BRANDS.ALMOSAFER]: "https://tjwlcdn.com/cms/rebranding/assets/alm-fb-logo-en.jpg"
};
exports.OPEN_GRAPH_IMAGE = OPEN_GRAPH_IMAGE;
const BRANDS_PREFIX = {
  TAJAWAL: "TJ",
  ALMOSAFER: "AM"
};
exports.BRANDS_PREFIX = BRANDS_PREFIX;
const ENV = {
  LOCAL: "local",
  DEV: "dev",
  LIVE: "live",
  STAGING: "staging"
};
exports.ENV = ENV;
const LOCALES = {
  EN: "en_us",
  AR: "ar_sa"
};
exports.LOCALES = LOCALES;
const LANGUAGE = {
  EN: "en",
  AR: "ar"
};
exports.LANGUAGE = LANGUAGE;
const COUNTRY_CURRENCY_MAP = {
  EG: "EGP",
  SA: "SAR",
  AE: "AED",
  KW: "KWD",
  BH: "BHD",
  US: "USD"
};
exports.COUNTRY_CURRENCY_MAP = COUNTRY_CURRENCY_MAP;
const DOMAINS = {
  TJ_LIVE_COM: "liveCom",
  TJ_LIVE_SA: "liveSa",
  TJ_DEV_SA: "devSa",
  TJ_DEV_COM: "devCom",
  TJ_LIVE_BH: "liveBh",
  TJ_DEV_BH: "devBh",
  TJ_LIVE_AE: "liveAe",
  TJ_DEV_AE: "devAe",
  TJ_LIVE_KW: "liveComKw",
  TJ_DEV_KW: "devComKw",
  AM_LIVE_COM: "liveMoCom",
  AM_DEV_COM: "devMoCom",
  AM_LIVE_AE: "liveMoAe",
  AM_DEV_AE: "devMoAe",
  AM_LIVE_KW: "liveMoKw",
  AM_DEV_KW: "devMoKw",
  AM_LIVE_BH: "liveMoBh",
  AM_DEV_BH: "devMoBh"
};
exports.DOMAINS = DOMAINS;
const EMAILS = {
  TJ_SUPPORT: "support@tajawal.com",
  AM_SUPPORT: "support@almosafer.com",
  AM_FLIGHTS_SUPPORT: "flightsupport@almosafer.com"
};
exports.EMAILS = EMAILS;
const CREDIT_CARDS = {
  VISA: "visa",
  MASTER_CARD: "master-card",
  AMERICAN_EXPRESS: "american-express",
  MADA: "mada",
  QITAF: "QITAF",
  KNET: "KNET"
};
exports.CREDIT_CARDS = CREDIT_CARDS;
const DATA_SOURCES = {
  CACHE: "cache",
  NETWORK: "network"
};
exports.DATA_SOURCES = DATA_SOURCES;
const VAT_COUNTRIES = {
  UAE: "UAE",
  SA: "KSA"
};
exports.VAT_COUNTRIES = VAT_COUNTRIES;
const COUNTRY_CODE = {
  KW: "KW",
  BH: "BH",
  AE: "AE",
  SA: "SA",
  GLOBAL: "GLOBAL"
};
exports.COUNTRY_CODE = COUNTRY_CODE;
const ALLOWED_CURRENCIES = ["SAR", "AED", "QAR", "KWD", "BHD", "USD", "EUR", "GBP", "EGP"];
exports.ALLOWED_CURRENCIES = ALLOWED_CURRENCIES;
const COUNTRY_CODE_MAP = {
  KW: "Kuwait",
  BH: "Bahrain",
  AE: "United Arab Emirates",
  SA: "Saudi Arabia",
  GLOBAL: "International"
};
exports.COUNTRY_CODE_MAP = COUNTRY_CODE_MAP;
const VAT_COUNTRIES_MAP = {
  [BRANDS.TAJAWAL]: {
    [COUNTRY_CODE.AE]: "UAE",
    default: "UAE"
  },
  [BRANDS.ALMOSAFER]: {
    [COUNTRY_CODE.SA]: "KSA",
    [COUNTRY_CODE.AE]: "UAE",
    [COUNTRY_CODE.KW]: "Kuwait",
    default: "KSA"
  }
};
exports.VAT_COUNTRIES_MAP = VAT_COUNTRIES_MAP;
const POSConfig = {
  almosafer: {
    [COUNTRY_CODE.KW]: {
      code: COUNTRY_CODE.KW,
      url: "https://kw.almosafer.com",
      devUrl: "https://next-dev-kw.almosafer.com",
      name: COUNTRY_CODE_MAP[COUNTRY_CODE.KW]
    },
    [COUNTRY_CODE.BH]: {
      code: COUNTRY_CODE.BH,
      url: "https://bh.almosafer.com",
      devUrl: "https://next-dev-bh.almosafer.com",
      name: COUNTRY_CODE_MAP[COUNTRY_CODE.BH]
    },
    [COUNTRY_CODE.AE]: {
      code: COUNTRY_CODE.AE,
      url: "https://ae.almosafer.com",
      devUrl: "https://next-dev-ae.almosafer.com",
      name: COUNTRY_CODE_MAP[COUNTRY_CODE.AE]
    },
    [COUNTRY_CODE.SA]: {
      code: COUNTRY_CODE.SA,
      url: "https://sa.almosafer.com",
      devUrl: "https://next-dev-sa.almosafer.com",
      name: COUNTRY_CODE_MAP[COUNTRY_CODE.SA]
    },
    [COUNTRY_CODE.GLOBAL]: {
      code: COUNTRY_CODE.GLOBAL,
      url: "https://almosafer.com",
      devUrl: "https://next-dev.almosafer.com",
      name: COUNTRY_CODE_MAP[COUNTRY_CODE.GLOBAL]
    }
  },
  tajawal: {
    [COUNTRY_CODE.KW]: {
      code: COUNTRY_CODE.KW,
      url: "https://tajawal.com.kw",
      devUrl: "https://next-dev.tajawal.com.kw",
      name: COUNTRY_CODE_MAP[COUNTRY_CODE.KW]
    },
    [COUNTRY_CODE.BH]: {
      code: COUNTRY_CODE.BH,
      url: "https://tajawal.bh",
      devUrl: "https://next-dev.tajawal.bh",
      name: COUNTRY_CODE_MAP[COUNTRY_CODE.BH]
    },
    [COUNTRY_CODE.AE]: {
      code: COUNTRY_CODE.AE,
      url: "https://tajawal.ae",
      devUrl: "https://next-dev.tajawal.ae",
      name: COUNTRY_CODE_MAP[COUNTRY_CODE.AE]
    },
    [COUNTRY_CODE.SA]: {
      code: COUNTRY_CODE.SA,
      url: "https://tajawal.sa",
      devUrl: "https://next-dev.tajawal.sa",
      name: COUNTRY_CODE_MAP[COUNTRY_CODE.SA]
    },
    [COUNTRY_CODE.GLOBAL]: {
      code: COUNTRY_CODE.GLOBAL,
      url: "https://tajawal.com",
      devUrl: "https://next-dev.tajawal.com",
      name: COUNTRY_CODE_MAP[COUNTRY_CODE.GLOBAL]
    }
  }
};
exports.POSConfig = POSConfig;
const APP_ROUTES = {
  FLIGHTS_HOME: "/{language}/flights-home",
  FLIGHTS_RESULTS_V1: "/{language}/v1/flights/{query}",
  FLIGHTS_RESULTS: "/{language}/flights/{query}",
  FLIGHTS_PAX: "/{language}/flight/traveller/{cartId}",
  FLIGHTS_PAYMENT: "/{language}/flight/seat/{cartId}"
};
exports.APP_ROUTES = APP_ROUTES;
const APP_PAGES = {
  FLIGHTS_HOME: "FLIGHTS_HOME",
  FLIGHTS_RESULTS_V1: "FLIGHTS_RESULTS_V1",
  FLIGHTS_RESULTS: "FLIGHTS_RESULTS",
  FLIGHTS_PAX: "FLIGHTS_PAX",
  FLIGHTS_PAYMENT: "FLIGHTS_PAYMENT",
  FLIGHTS_CONFIRMATION: "FLIGHTS_CONFIRMATION",
  FLIGHTS_MANAGE_BOOKING: "FLIGHTS_MANAGE_BOOKING",
  HOTELS_HOME: "HOTELS_HOME",
  HOTELS_RESULTS: "HOTELS_RESULTS",
  HOTELS_DETAILS: "HOTELS_DETAILS",
  HOTELS_GUEST: "HOTELS_GUEST",
  HOTELS_PAYMENT: "HOTELS_PAYMENT",
  HOTELS_CONFIRMATION: "HOTELS_CONFIRMATION",
  HOTELS_MANAGE_BOOKING: "HOTELS_MANAGE_BOOKING"
};
exports.APP_PAGES = APP_PAGES;
const EMAIL_REGEX = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2,})\b$/;
exports.EMAIL_REGEX = EMAIL_REGEX;
const SPECIAL_FORMAT_DIAL_CODES = ["+971", "+966"];
exports.SPECIAL_FORMAT_DIAL_CODES = SPECIAL_FORMAT_DIAL_CODES;
const LOWEST_VALID_PHONE_NUMBER = 5;
exports.LOWEST_VALID_PHONE_NUMBER = LOWEST_VALID_PHONE_NUMBER;
const VALID_NUMBER_WITHOUT_ZERO_IN_BEGINNING = 9;
exports.VALID_NUMBER_WITHOUT_ZERO_IN_BEGINNING = VALID_NUMBER_WITHOUT_ZERO_IN_BEGINNING;
const VALID_NUMBER_WITH_ZERO_IN_BEGINNING = 10;
exports.VALID_NUMBER_WITH_ZERO_IN_BEGINNING = VALID_NUMBER_WITH_ZERO_IN_BEGINNING;
const HOUR_MINUTES = 60;
exports.HOUR_MINUTES = HOUR_MINUTES;